
// estratoService.js
import api from './api';

export const estratoService = {
    obtenerTodos: () => api.get('/get/obtener_estratos.php')
        .then(response => ({
            data: Array.isArray(response.data) ? response.data : response.data?.data || []
        }))
};